module.exports = __webpack_public_path__ + "img/certif_011.44ed4d14.jpg";